import { render, staticRenderFns } from "./WarnText.vue?vue&type=template&id=61aa4b06"
import script from "./WarnText.vue?vue&type=script&lang=js"
export * from "./WarnText.vue?vue&type=script&lang=js"
import style0 from "./WarnText.vue?vue&type=style&index=0&id=61aa4b06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports